import React from 'react';

const FinancialTabsNav = ({ tabs, activeTab, onTabChange }) => (
  <div className="mb-4 sm:mb-6 md:mb-8">
    {/* Mobile-friendly pill nav */}
    <div className="md:hidden">
      <div className="flex gap-2 overflow-x-auto pb-2 -mx-3 px-3 scrollbar-hide" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`shrink-0 inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs sm:text-sm font-medium transition-colors touch-manipulation ${
                isActive ? 'bg-blue-600 text-white shadow-md' : 'bg-gray-100 text-gray-600 active:bg-gray-200'
              }`}
              aria-current={isActive ? 'page' : undefined}
            >
              <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
              <span>{tab.name}</span>
            </button>
          );
        })}
      </div>
    </div>

    {/* Desktop tab nav */}
    <div className="hidden md:block border-b border-gray-200">
      <nav className="-mb-px flex space-x-8">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`flex items-center space-x-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                isActive
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
              aria-current={isActive ? 'page' : undefined}
            >
              <Icon className="w-4 h-4" />
              <span>{tab.name}</span>
            </button>
          );
        })}
      </nav>
    </div>
  </div>
);

export default FinancialTabsNav;
